import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PaginationMeta } from '../../../models/pagination-meta.model';
import { MdbButtonComponent } from '../mdb-button/mdb-button.component';

@Component({
  selector: 'app-list-pagination-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, TranslateModule, MdbButtonComponent],
  templateUrl: './list-pagination-bar.component.html',
  standalone: true,
  styleUrl: './list-pagination-bar.component.scss',
})
export class ListPaginationBarComponent {
  /** Pagination meta from list response; used for current/last page and per_page. */
  meta = input.required<PaginationMeta>();
  /** Options for per-page select (e.g. [10, 25, 50, 100]). */
  perPageOptions = input.required<number[]>();
  /** When true, disables per-page select and prev/next buttons. */
  loading = input(false);
  /** Optional id for the per-page select (for a11y). */
  selectId = input('list-pagination-per-page');

  perPageChange = output<number>();
  previousClicked = output<void>();
  nextClicked = output<void>();

  onPerPageChange(value: string): void {
    const n = Number(value);
    if (!Number.isNaN(n)) {
      this.perPageChange.emit(n);
    }
  }

  previous(): void {
    if (this.loading()) return;
    if (this.meta().current_page <= 1) return;
    this.previousClicked.emit();
  }

  next(): void {
    if (this.loading()) return;
    if (this.meta().current_page >= this.meta().last_page) return;
    this.nextClicked.emit();
  }
}
